import styled from "@emotion/styled";
import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_COLLAPSED,
} from "../Navigation/Sidebar.styles";

/**
 * Shifts the page across to clear the fixed sidebar.
 *
 * <p>The sidebar is fixed so it does not scroll with the page, which means it takes no space in
 * the flow and this margin has to stand in for it. Below the breakpoint the sidebar becomes an
 * overlay drawer, so the margin goes away entirely.
 */
export const LayoutWrapper = styled.div<{ $collapsed: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-left: ${({ $collapsed }) =>
    $collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH};
  background-color: ${({ theme }) => theme.colors.background};
  transition: margin-left 0.18s ease;

  @media (max-width: 64rem) {
    margin-left: 0;
  }
`;

export const MainContent = styled.main`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.xl};

  @media (max-width: 48rem) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;

/** Full-width strip above everything for balance problems that stop tracking working. */
export const AlertBanner = styled.div<{ $tone: "danger" | "warning" }>`
  padding: 0.55rem 1rem;
  text-align: center;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #fff;
  background-color: ${({ $tone, theme }) =>
    $tone === "danger" ? theme.colors.danger : theme.colors.warning};
`;
